/** ALP-84 S3: the new app shell (sidebar groups, org switcher, topbar, palette, shortcuts, phone More sheet). Plan §6.1 vocabulary. */
export const appShell = {
  groups: {
    engage: "Engage",
    content: "Content",
    automate: "Automate",
    insights: "Insights",
    collapse: "Collapse {{group}}",
    expand: "Expand {{group}}",
  },
  nav: {
    label: "Main",
    home: "Home",
    inbox: "Inbox",
    approvals: "Approvals",
    people: "People",
    everyone: "Everyone",
    commenters: "Commenters",
    calendar: "Calendar",
    posts: "Posts",
    studio: "AI Studio",
    rules: "Rules",
    agents: "AI agents",
    log: "Automation log",
    dashboards: "Dashboards",
    analytics: "Analytics",
    settings: "Settings",
    admin: "Platform admin",
    compose: "Create post",
    jobs: "Jobs",
    assistant: "Assistant",
    more: "More",
  },
  org: {
    label: "Organization",
    switch: "Switch organization",
    yours: "Your organizations",
    create: "Create organization",
    switched: "You're now in {{name}}",
    current: "Current organization",
  },
  topbar: {
    searchOrAsk: "Search or ask…",
    ask: "Ask",
    askHint: "Ask the assistant",
    reconnecting: "Reconnecting…",
    offline: "Offline",
    connection: "Connection",
    live: "Live",
    breadcrumb: "Breadcrumb",
  },
  avatar: {
    theme: "Theme",
    help: "Help & legal",
    privacy: "Privacy policy",
    terms: "Terms of service",
    dataDeletion: "Data deletion",
  },
  palette: {
    recent: "Recent",
    organizations: "Organizations",
    settings: "Settings",
    askQuery: "Ask the assistant: “{{q}}”",
    newAgent: "Create an AI agent",
    newDashboard: "Create a dashboard",
    invite: "Invite a teammate",
    connect: "Connect Instagram",
    floatingOn: "Show the floating Ask button",
    floatingOff: "Hide the floating Ask button",
  },
  shortcuts: {
    goTo: "Go to",
    ask: "Open the assistant",
    holdSpace: "Hold Space",
    goPeople: "Go to People",
    goPosts: "Go to Posts",
    goStudio: "Go to AI Studio",
    goRules: "Go to Rules",
    goAgents: "Go to AI agents",
    goLog: "Go to Automation log",
    goDashboards: "Go to Dashboards",
    goSettings: "Go to Settings",
    goJobs: "Go to Jobs",
    goAssistant: "Go to the Assistant",
    aliases: "G U (Rules) still works.",
  },
  floating: {
    title: "Floating Ask button",
    hint: "Adds a floating Ask button at the bottom of every page. The Ask button in the top bar and {{key}} J always work.",
    label: "Show the floating Ask button",
  },
};
